<!--
<wlm-side-panel
  [map]="map"
  [layers]="layers"
  [id]="sidePanelId"
  [sidePanelSettings]="sidePanelSettings"
  class="leaflet-sidebar collapsed"
></wlm-side-panel>
-->
<wlm-map-time-bar
  [id]="timeBarId"
  [map]="map"
  [initialMapDateRange]="mapDateRange"
></wlm-map-time-bar>

<wlm-map-top-bar-buttons
  [id]="topBarId"
  [map]="map"
  [topBarConfiguration]="topBarConfiguration"
></wlm-map-top-bar-buttons>

<div class="map-container">
  <div class="map-frame">
    <div #mapContainer class="map" id="map"></div>
  </div>
</div>
